import styled from 'styled-components';

export const PencilIcon = styled.i.attrs({
  className: 'fa-light fa-pencil fa-lg',
})`
  text-align: center;
  width: 100%;
  height: 100%;
  top: 50%;
  position: absolute;
`;

export const TrashIcon = styled.i.attrs({
  className: 'fa-light fa-trash fa-lg',
})`
  text-align: center;
  width: 100%;
  position: absolute;
`;

export const IconGroup = styled.div`
  display: flex;
  justify-content: end;
`;

export const PlusIcon = styled.i.attrs({
  className: 'fa-solid fa-plus fa-lg',
})`
  margin-left: 5px;
`;
